import {Button} from '@mintdata-wsp/common/components/button/Button';
import {Form, IFormData} from '@mintdata-wsp/common/components/form/Form';
import {ErrorPopupSide} from '@mintdata-wsp/common/components/formField/FormField';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Input} from '@mintdata-wsp/common/components/input/Input';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogError} from '@mintdata-wsp/wsp/ui/components/forms/DialogError';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Spinner, SpinnerSize, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {TextRun} from '@mintdata-wsp/wsp/ui/components/text/TextRun';
import {links} from '@mintdata-wsp/wsp/ui/routes/Routing';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./NewPasswordForm.less');
const cx = classnames.bind(styles);

@observer
export class NewPasswordForm extends React.Component<RouteComponentProps<any>, any>
{
    private _form:Form = new Form({
        onSubmit: this._onFormSubmit,
    });
    // private _form:Form = new Form({onChange: this._onFormChanged} as FormProps);

    // private _validators = new NewPasswordValidators({_form: this._form});

    // @observable
    // private _serverError:string = '';

    // @observable
    // private _isMainButtonDisabled:boolean = true;

    // constructor(props:any)
    // {
    //     super(props);
    // }

    componentDidMount()
    {
        const {token} = this.props.match.params;

        console.log('token =', token);

        controllers.ui.newPassword.setToken(token);
        controllers.ui.newPassword.checkToken();
    }

    @bind
    private _onFormSubmit(formData:IFormData)
    {
        controllers.ui.newPassword.submitForm(this._form);
    }

    @bind
    private _onClickSubmitButton(e:React.SyntheticEvent<any>):void
    {
        this._form.submit();
    }

    private _getSpinner(style:SpinnerStyle, className?:string):JSX.Element
    {
        return <Spinner size={SpinnerSize.Medium_24} style={style} className={cx(className)} />;
    }

    // @bind
    // private _onFormChanged(fieldKey:string, fieldValue:any, isValid:boolean):void
    // {
    //     this._checkUiState();
    // }

    // @action.bound
    // private _checkUiState():void
    // {
    //     const areSomeFieldChanged = this._form.areSomeFieldChanged();
    //     const areAllFieldsValid = this._form.areAllFieldsValid();
    //
    //     this._isMainButtonDisabled = !areAllFieldsValid || areAllFieldsValid && !areSomeFieldChanged;
    // }

    // @action.bound
    // _onClickSetNewPassword()
    // {
    //     if (this._isMainButtonDisabled)
    //         return;
    //
    //     this._isMainButtonDisabled = true;
    //
    //     const newPassword = md5(this._form.get('newPassword'));
    //
    //     controllers.user.newPassword(new NewPasswordRequest('TODO token', newPassword))
    //     .then(action(()=>
    //     {
    //         controllers.navigation.toLogin();
    //     }))
    //     .catch(action((err:ApiError)=>
    //     {
    //         if (ApiError.isError(err))
    //         {
    //             this._serverError = err.message;
    //         }
    //     }));
    // }

    render()
    {
        const { isTokenChecked,
                isCheckTokenInProgress,
                checkTokenResponse,
                isTokenValid,
                isNewPasswordInProgress } = rootState.ui.newPasswordPage;

        const controller = controllers.ui.newPassword;

        const viewForm = checkTokenResponse && checkTokenResponse.allowed;

        const commonErrorMessage = this._form.getServerError('_');

        const isInvalidToken = isTokenChecked && !isTokenValid;

        return  (
            <Dialog
                className={cx('newPasswordDialog')}
                title={isInvalidToken ? '' : 'New Password'}
                >

                <DialogError message={commonErrorMessage} />

                {isCheckTokenInProgress && (
                    <Row className={cx('infoText')}>
                        Checking token...
                        {this._getSpinner(SpinnerStyle.Blue, 'checkTokenSpinner')}
                    </Row>
                )}

                {isInvalidToken && (
                    <TextRun className={cx('infoText')}>
                        Oops! Something went wrong.
                        <br/>
                        Please {links.toForgotPassword('reset')} your password again.
                    </TextRun>
                )}

                {viewForm && (
                    <div className={cx('newPasswordForm')}>

                        <Column>

                            <Input className={cx('input')}
                                   icon={MDIcons.common.PasswordKey}
                                   placeholder={'New password'}
                                   isPassword={true}
                                   form={this._form}
                                   formKey={'newPassword'}
                                   isInitiallyFocused={true}
                                   validationFn={controller.validateNewPassword}
                                   errorPopupSide={ErrorPopupSide.Right}
                            />

                            <Input className={cx('input')}
                                   icon={MDIcons.common.PasswordKey}
                                   placeholder={'Re-type password'}
                                   isPassword={true}
                                   form={this._form}
                                   formKey={'retypePassword'}
                                   validationFn={controller.validateRetypePassword}
                                   errorPopupSide={ErrorPopupSide.Right}
                            />

                        </Column>

                        <Row className={cx('mainButtonRow')}>
                            <Button
                                caption={'Set New Password'}
                                className={cx('mainButton')}
                                onClick={this._onClickSubmitButton}
                                icon={isNewPasswordInProgress ? this._getSpinner(SpinnerStyle.White) : null}
                                relativeIcon={true}
                                isDisabled={isNewPasswordInProgress}
                                />
                        </Row>

                    </div>
                )}

            </Dialog>
        );
    }
}
